const MONTHS_ES = [
  'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
  'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'
];

export function formatDateEs(dateStr: string): string {
  if (!dateStr) return '';
  const [, m, d] = dateStr.split('-');
  const monthIdx = parseInt(m, 10) - 1;
  if (Number.isNaN(monthIdx) || monthIdx < 0 || monthIdx > 11) return dateStr;
  return `${parseInt(d, 10)} de ${MONTHS_ES[monthIdx]}`;
}
